export var createAutoRoutingApi = function (baseUrl, http) {
    var autoRoutingUrl = baseUrl + "/autoRouting";
    var enableApiUrl = autoRoutingUrl + '/feature/enable';
    var disableApiUrl = autoRoutingUrl + '/feature/disable';
    var workloadApiUrl = autoRoutingUrl + '/workload';
    var acceptTimeApiUrl = autoRoutingUrl + '/acceptTime';
    var groupsApiUrl = autoRoutingUrl + '/groups';
    return {
        getAutoRoutingSettings: function () {
            return http.get(autoRoutingUrl);
        },
        enableAutoRoutingFeature: function (dto) {
            return http.post(enableApiUrl, dto);
        },
        disableAutoRoutingFeature: function (dto) {
            return http.post(disableApiUrl, dto);
        },
        setAutoRoutingFeatureWorkload: function (dto) {
            return http.put(workloadApiUrl, dto);
        },
        setAutoRoutingFeatureAcceptTime: function (dto) {
            return http.put(acceptTimeApiUrl, dto);
        },
        addAutoRoutingGroup: function (dto) {
            return http.post(groupsApiUrl + "/" + dto.groupId, dto);
        },
        removeAutoRoutingGroup: function (dto) {
            return http.delete(groupsApiUrl + "/" + dto.groupId);
        },
        setAutoRoutingGroup: function (dto) {
            return http.put(groupsApiUrl, dto);
        },
    };
};
//# sourceMappingURL=index.js.map